<!--
Author: TangChen
Date: 2018-09-19
Desc: 协议内容
-->
<template>
    <div class="comp-ben-info comp">
        <el-row class="taxes-box two-cols-form ">
            <el-form
                ref="benInfo"
                :model="benInfo"
                :rules="rules"
                label-width="160px"
                class="acct-form"
                size="small"
                v-on:submit.native.prevent
            >
                <el-col :span="12">
                    <el-form-item label="受益人所属类型：" class="required" prop="custorgtype">
                        <el-select
                            v-model="benInfo.custorgtype"
                            filterable
                            placeholder="请选择受益人所属类型"
                        >
                            <el-option
                                v-for="item in $cache.getDict('120125')"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="受益人类型：" class="required" prop="beneficiarytp">
                        <el-select
                            v-model="benInfo.beneficiarytp"
                            filterable
                            placeholder="请选择受益人类型"
                        >
                            <el-option
                                v-for="item in $cache.getDict('120126')"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="受益人名称：" prop="beneficiaryname" class="required">
                        <el-input
                            v-model="benInfo.beneficiaryname"
                            placeholder="请输入受益人名称"
                            :maxlength="32"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="证件类型：" class="required" prop="benefcertype">
                        <el-select
                            v-model="benInfo.benefcertype"
                            filterable
                            placeholder="请选择证件类型"
                        >
                            <el-option
                                v-for="item in benefcertype"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="证件号码：" prop="benefcerno" class="required">
                        <el-input
                            v-model="benInfo.benefcerno"
                            placeholder="请输入证件号码"
                            :maxlength="32"
                        />
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item label="证件有效期：" prop="beneficiarydate" :class="{'required':!benInfo.birthdate}">
                        <date-picker :date="beneficiaryDateSet" v-on:date-get="beneficiaryDateInterval" />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="受益人地址：" prop="beneficiaryaddress">
                        <el-input
                            v-model="benInfo.beneficiaryaddress"
                            placeholder="请输入受益人通讯地址"
                            :maxlength="64"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="控制权结构证明：" class="required" prop="controlstructure">
                        <el-select
                            v-model="benInfo.controlstructure"
                            filterable
                            placeholder="请选择控制权结构证明"
                        >
                            <el-option
                                v-for="item in $cache.getDict('110045')"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="资金来源：" prop="assetssource">
                        <el-input
                            v-model="benInfo.assetssource"
                            placeholder="请输入资金来源"
                            :maxlength="32"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="备注：" prop="remark">
                        <el-input
                            v-model="benInfo.remark"
                            :maxlength="64"
                        />
                    </el-form-item>
                </el-col>
                <!-- <el-col v-if="isPwdCheck" :span="12">
                    <el-form-item label="交易密码：" prop="pwd" class="required">
                        <el-input
                            v-model="benInfo.pwd"
                            type="password"
                            placeholder="请输入交易密码"
                            :maxlength="16"
                        />
                    </el-form-item>
                </el-col> -->
                <el-col :span="24" class="btn-group">
                    <el-button type="yellow" class="medium" v-on:click="submitInfo('benInfo')">
                        保存
                    </el-button>
                    <el-button class="medium" v-on:click="$router.back()">
                        返回
                    </el-button>
                </el-col>
            </el-form>
        </el-row>
    </div>
</template>
<script>
import format from "date-fns/format";
import datePicker from "@/components/common/datePicker.vue";
import { get } from "http";
export default {
    name: "CrsInfo",
    components: {
        datePicker
    },
    props: {
        fn: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            benInfo: {
                investorsbirthday: "",
                existbenef: "",
                exemption: "",
                otherreason: "",
                custorgtype: "",
                beneficiarytp: "",
                beneficiaryname: "",
                benefcertype: "",
                benefcerno: "",
                beneficiarydate: "",
                beneficiaryaddress: "",
                controlstructure: "",
                assetssource: "",
                remark: ""
            },
            checkbenInfo: {},
            benefcertype: [],
            beneficiaryDateSet: { type: "3", max: "", val: "",text: "请选择证件有效期" },
            isPwdCheck: false,
            rules: {
                exemption: [
                    { required: true, message: "请选择豁免原因", trigger: "change" }
                ],
                custorgtype: [
                    { required: true, message: "请选择受益人所属类型", trigger: "change" }
                ],
                beneficiarytp: [
                    { required: true, message: "请选择受益人类型", trigger: "change" }
                ],
                benefcertype: [
                    { required: true, message: "请选择证件类型", trigger: "change" }
                ],
                beneficiarydate: [
                    { required: true, message: "请选择证件有效期", trigger: "change" }
                ],
                controlstructure: [
                    { required: true, message: "请选择控制权结构证明", trigger: "change" }
                ],
                // assetssource: [
                //     { required: true, message: "请输入资金来源", trigger: "blur" }
                // ],
                benefcerno: [
                    { required: true, message: "请输入证件号码", trigger: "blur" },
                    {validator: this.checkCertNo, trigger: "blur"}
                ],
                beneficiaryname: [
                    { required: true, message: "请输入受益人名称", trigger: "blur" }
                ],
                otherreason: [
                    { required: true, message: "请输入其他原因", trigger: "blur" }
                ]
            }
        };
    },
    watch: {
        "benInfo.existbenef" (val) {
            if (val === "0") {
                this.benInfo.exemption = "",
                this.benInfo.otherreason = "";
            }
            if (val === "1") {
                this.benInfo.otherreason = "";
            }
            if (val === "2") {
                this.benInfo.exemption = "0";
            }
        },
        "benInfo.beneficiaryinvtp"(val){
            this.benInfo.benefcertype = "";
            if (this.benInfo.beneficiaryinvtp == 0) {
                this.benefcertype = this.$cache.getDict("130008") || [];
            }else {
                this.benefcertype = this.$cache.getDict("130007") || [];
            }
        }
    },
    created () {
        // 初始化数据字典值
        this.isPwdCheck = this.$cache.getPwdCheck("B1");
        const info = this.$cache.getUser();
        const conf = this.$util.getConfig().const;
        this.beneficiaryDateSet.max = this.$util.fmtDate(conf.CARD_DATE_MAX);
        this.benInfo.investorsbirthday = info.birthdate;
        // if(this.$route.query.benInfo){
        //     this.benInfo = this.$route.query.benInfo;
        //     this.beneficiaryDateSet.val = this.$util.fmtDate(this.benInfo.beneficiarydate);
        // }
        // this.$set(this.benInfo,"existbenef",info.existbenef);
        // this.$set(this.benInfo,"otherreason",info.otherreason);
        // this.$set(this.benInfo,"exemption",info.exemption);
        this.beneficiaryid = this.$route.query.beneficiaryid;
        this.benefcertype = info.beneficiaryinvtp == 0 ? this.$cache.getDict("130008") : this.$cache.getDict("130007") || [];
        if(this.beneficiaryid)
            this.getCollectionInfo(this.beneficiaryid);
    },
    methods: {
        /* 校验证件号码 */
        checkCertNo (rule, value, callback) {
            this.$util.validateCertNo(rule, value, callback, this.benInfo.benefcertype,true);
        },
        beneficiaryDateInterval (val) {
            this.benInfo.beneficiarydate = val !== null ? val.replace(/-/g, "") : "";
            this.$refs.benInfo.validateField("beneficiarydate");
        },

        getCollectionInfo (beneficiaryid) {
            const _this = this;
            this.$util.request("anon/orgBeneficiary",{ beneficiaryserialno: "" }).then(res => {
                if (res.data) {
                    const _a = res.data;
                    let info = _a.filter(item => {
                        return item.beneficiaryid == beneficiaryid;
                    });
                    this.benInfo = info[0];
                    this.checkbenInfo = Object.assign({}, this.checkbenInfo, this.benInfo);

                    this.beneficiaryDateSet.val = this.$util.fmtDate(this.benInfo.beneficiarydate);
                }
            });
        },
        /* 提交表单数据，校验用户信息 */
        submitInfo (formName) {
            const _this = this;
            _this.checkbenInfo.pwd = _this.benInfo.pwd;
            if(JSON.stringify(_this.checkbenInfo) == JSON.stringify(_this.benInfo)) {
                _this.$message({
                    type: "info",
                    message: "表单数据未改变，请勿重复提交"
                });
                return;
            }
            _this.$refs[formName].validate(valid => {
                if (valid) {
                    const way = (_this.beneficiaryid) ? "PUT" : "POST";
                    const _x = Object.assign({}, _this.benInfo);
                    _this.$util.request("anon/orgBeneficiary", _x, way).then(res => {
                        const msg = way === "PUT" ? "修改" : "新增";
                        if (res.data) {
                            const info = _this.$cache.getUser();
                            _this.$store.dispatch("setInfo", info).then(() => {
                                _this.$message({
                                    type: "success",
                                    message: msg + "受益人信息成功" + (_this.fn ? "" : "，3秒后回到信息中心"),
                                    onClose: function () {
                                        if (_this.fn) { _this.$emit("fn-back", true); } else {
                                            _this.$router.push({ name: "orginfo" });
                                        }
                                    }
                                });
                            });
                        } else {
                            _this.$message({
                                type: "warning",
                                message: res.msg
                            });
                        }
                    });

                } else {
                    return false;
                }
            });
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.comp-ben-info {
    .el-col.el-col-12 {
        height: 51px;
        overflow: hidden;
    }
    .taxes-box {
        padding: 30px 30px 45px;
    }
}
</style>
